import { UnstyledButtonType } from '@components/SearchBars/SearchFigma/types';
import { Dialog, UnstyledButton } from '@mantine/core';
import { Elevation3 } from '@services/mantine';
import styled from 'styled-components';

export const ScrollButton: UnstyledButtonType = styled(UnstyledButton)`
  && {
    color: #fff;
    border: 1px solid var(--beam-color-neutral-n400);
    border-radius: 50%;
    background-color: var(--beam-color-neutral-n800);

    box-shadow: ${Elevation3.boxShadow};
  }

  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledDialog = styled(Dialog)`
  && {
    width: 42px;
    height: 42px;
    padding: 0;
    background-color: transparent;
    border: none;
    min-height: 0;
    box-shadow: none;
  }
`;
